import { render, staticRenderFns } from "./CourseSelectDialog2.vue?vue&type=template&id=01799696&scoped=true"
import script from "./CourseSelectDialog2.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseSelectDialog2.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CourseSelectDialog2.vue?vue&type=style&index=0&id=01799696&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01799696",
  null
  
)

export default component.exports